import {Box, Stack, styled} from '@mui/material';

const StyledContainer = styled(Stack)`
	margin: 0 auto;
	width: 100%;
	padding: 16px 16px 64px;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px 32px 16px;
	}

	${({theme}) => theme.breakpoints.up('md')} {
		max-width: 600px;
	}
`;

const StyledWrapper = styled(Box)`
	position: relative;
	width: 100%;
`;

const StyledLogoContainer = styled(Box)`
	display: block;
	padding: 16px 16px 0;

	${({theme}) => theme.breakpoints.up('sm')} {
		display: block;
		position: absolute;
		left: 32px;
		top: 32px;
		padding: 0;
	}
`;

const Container = styled('div')`
	opacity: 0;
	position: absolute;
	width: 100%;
	z-index: -1;
`;

export {StyledContainer, StyledWrapper, StyledLogoContainer, Container};
